import styled from 'styled-components/macro';
import ReactTooltip from 'react-tooltip';

const Tooltip = styled(ReactTooltip)`
  min-width: 64px;
  text-align: ${({ textAlign }) => textAlign || 'center'} !important;
  padding: 20px 16px !important;
  opacity: 1 !important;
  border-radius: 4px !important;
  border: solid 1px ${({ theme }) => theme.colours.coldgrey300} !important;
  color: ${({ theme }) => theme.colours.coldgrey600} !important;
  background-color: ${({ theme }) => theme.colours.coldgrey100} !important;
  box-shadow: ${({ theme }) => theme.shadows.light[4]} !important;
  width: ${({ width = 'auto' }) => (typeof width === 'number' ? `${width}px` : width)} !important;
  max-width: ${({ maxWidth = 232 }) => (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth)} !important;
  ${({ theme }) => `
    font-family: ${theme.fonts.regular} !important;
    font-size: ${theme.typography.helper.fontSize} !important;
    font-weight: ${theme.typography.helper.fontWeight} !important;
  `}

  &.place-top { 
    &::after {
      border-top-color: ${({ theme }) => theme.colours.coldgrey100} !important;
    }
  }

  &.place-left { 
    &::after {
      border-left-color: ${({ theme }) => theme.colours.coldgrey100} !important;
    }
  }

  &.place-bottom { 
    &::after {
      border-bottom-color: ${({ theme }) => theme.colours.coldgrey100} !important;
    }
  }

  &.place-right { 
    &::after {
      border-right-color: ${({ theme }) => theme.colours.coldgrey100} !important;
    }
  }
`;

export default Tooltip;
